export const MIN_INPUT_LENGTH_WARNING = 40;
export const MAX_INPUT_LENGTH_WARNING = 60;

export const DEFAULT_PLACEHOLDER = 'Open Graph Title';
export const DEFAULT_LABEL = 'Open Graph Title';
export const DEFAULT_NAME = 'seoOgTitle';
export const DEFAULT_HELP_TOOLTIP_MESSAGE = `Enter a clear, descriptive title that will appear when your content is shared on social media. Keep it between ${MIN_INPUT_LENGTH_WARNING}-${MAX_INPUT_LENGTH_WARNING} characters for the best display across platforms like Facebook and Twitter. If left empty, the default placeholder value is used.`;
